/**
 * Where an entity's Type control lives on its summary — the ONE switch for it.
 *
 *   "property"  a row in the property list, beside Workflow and Stage (the
 *               shipped placement)
 *   "hero"      one outline control above the title — the type's glyph, its
 *               name and a caret packed as one word, 16px over the title (the
 *               ClickUp task-hero grammar)
 *
 * Both renderings are wired everywhere the Type appears (the project summary,
 * the account header and properties widget, the contact header), so changing
 * the return value is the whole change. Keep both paths alive; neither is dead
 * code while this switch exists. A function, not a literal constant: TypeScript
 * narrows a `const` to its initializer and then rejects the comparison against
 * the other member as impossible.
 */
type TypePlacement = "property" | "hero";

export function typePlacement(): TypePlacement {
  return "property";
}

export const typeInHero: boolean = typePlacement() === "hero";
